import React, { useState, useEffect } from 'react';

import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import { useNavigate, Link } from 'react-router-dom';

import api from '../../../../Services/api';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js';

import MonthlyReport from '../../../../Component/Client/ClientMonthlyReport';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, ArcElement);

const COLORS = {
  success: '#0BDA51',
  overall: '#50c878',
  danger: '#B22222',
  notUploaded: 'white',
  warning: '#EFCC00'
};

const months = [
  { name: "JANUARY", value: "01" },
  { name: "FEBRUARY", value: "02" },
  { name: "MARCH", value: "03" },
  { name: "APRIL", value: "04" },
  { name: "MAY", value: "05" },
  { name: "JUNE", value: "06" },
  { name: "JULY", value: "07" },
  { name: "AUGUST", value: "08" },
  { name: "SEPTEMBER", value: "09" },
  { name: "OCTOBER", value: "10" },
  { name: "NOVEMBER", value: "11" },
  { name: "DECEMBER", value: "12" }
];

const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 2020 + 1 }, (x, i) => 2020 + i);

const AssessorEstablishmentReport = () => {
 

  const currentDate = new Date();
 
  const navigate = useNavigate();
  const currentMonth = currentDate.getMonth() + 1;
  const currentDay = currentDate.getDate();
  const previousMonthName = months[(currentMonth - 1 - 1 + 12) % 12].name;
        const [companyId,setCompanyId] = useState("");
  const [vendorsData, setVendorsData] = useState({});
        const [userType, setUserType] = useState('');

  const [vendorChartData1, setVendorChartData1] = useState({});
  const [isDataEmpty, setIsDataEmpty] = useState(false);
  const[loading,setLoading] = useState(true);
  const [report, setReport] = useState(false);
  const [assessorFormData, setAssessorFormData] = useState({
         assessorCompanyName: '',
         assessorId: '',
         companyId:''
       });
  const [showModal, setShowModal] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState(null);
  const [monthlyData, setMonthlyData] = useState({});  // Data for current month
  const [selectedMonthData, setSelectedMonthData] = useState({});  // Data for selected month (for report)
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
  const[selectedFilter,setSelectedFilter] = useState('all')
 
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
 
 useEffect(() => {
       const sessionData = sessionStorage.getItem('user');
       const parsed = JSON.parse(sessionData);
       const id = parsed.id;
       const type = parsed.type;
     
       setUserType(type); // optional, only if you're using it elsewhere
     
       // First get assessor details
       if(type==='assessor'){
       api.assessor.findOne(id)
         .then(response => {
           const assessorInfo = response.data.data;
           const companyIdFromAssessor = assessorInfo.companyId;
           setAssessorFormData(assessorInfo);
           setCompanyId(companyIdFromAssessor); // set this first
         sessionStorage.setItem('selectedCompanyId',companyIdFromAssessor)
         })
         .catch(error => {
           console.error('Error fetching company data:', error);
           setLoading(false);
         });
     } 
     }, [userType]); 

 

  // Fetch selected month data for the report when selectedMonth or selectedYear changes
  useEffect(() => {
    if (selectedMonth && selectedYear) {
       fetchSelectedMonthData(companyId, selectedMonth, selectedYear);
    }
  }, [selectedMonth, selectedYear]);

   
 
 
  
 
 
  const handleMonthChange = (event) => setSelectedMonth(event.target.value);
  const handleYearChange = (event) => setSelectedYear(event.target.value);
  // Fetch data for current month (status)
 

  // Fetch data for selected month (for report)
  const fetchSelectedMonthData = async (companyId, month, year) => {
    try {
      const response = await api.client.getEstablishmentMonthlyData(companyId, month, year);
      if (response.status === 200) {
        const chartData = response.data;
        setSelectedMonthData(chartData);
        setReport(true);
      } else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setReport(false);
      }
    } catch (error) {
      console.error('Error fetching selected month data', error);
    }
  };
  const handleFilterChange = (filter) => {
    const percentages = getRejectedAndNotUploadedPercentages(monthlyData);
  if (
    (filter === 'rejected' && percentages.rejectedPercent === 0) ||
    (filter === 'accepted' && percentages.acceptedPercentage === 0) ||
    (filter === 'underReview' && percentages.underReviewPercent === 0)
  ) {
  
    navigate('/monthly-data', {
      state: {
        // filter: 'all',
        month: currentMonth < 10 ? `0${currentMonth-1}` : currentMonth-1,
        year: currentYear,
      },
  }) 
}
else{
    navigate('/monthly-data', {
      state: {
        // filter: filter,
        month: currentMonth < 10 ? `0${currentMonth-1}` : currentMonth-1,
        year: currentYear,
      },
    });
  }
  };

  const getRejectedAndNotUploadedPercentages = (monthlyData) => {
    if (monthlyData && monthlyData.data) {
      const rejected = monthlyData.data.RejectedPercent || 0;  // Safe access to rejected percentage
      const underReview = monthlyData.data.UnderReviewPercent || 0;
      const accepted = monthlyData.data.AcceptedPercent || 0;  // Safe access to under review percentage
      return { rejectedPercent: rejected, underReviewPercent: underReview, acceptedPercentage: accepted };
  } else {
      // Handle the case where data might not be available
      console.error('Data is missing or incorrect structure');
      return { rejectedPercent: 0, underReviewPercent: 0 ,acceptedPercentage: 0};
  }
  };

  // useEffect(() => {
  //   const { acceptedPercentage } = getRejectedAndNotUploadedPercentages(monthlyData);
    
  //   console.log(acceptedPercentage,"percn")
  
  
  //   if (acceptedPercentage) {
  //     setAcceptedPercentage(acceptedPercentage); 
  //   } 
    
  // }, [monthlyData]); 
  

  // const StackedProgressBar = ({ segments, gap }) => {
  //  If all percentages are zero, return a message instead of a progress bar
  //   const totalPercentage = segments.reduce((total, segment) => total + segment.percentage, 0);
  //   console.log(totalPercentage,"totalPercentage")
  //   if (totalPercentage === 0) {
  //     return <div className="text-light">Not yet started</div>; // Show message when no data is available
  //   }
  
  //   return (
  //     <div style={{ width: '100%', height: '30px', display: 'flex', borderRadius: '0px', overflow: 'hidden', position: 'relative' }}>
  //       {segments.map((segment, index) => {
  //         const { percentage, color, label } = segment;
  //         const marginRight = `${gap || 0}px`;
  
  //         return (
  //           <div key={index} style={{ position: 'relative', width: `${percentage}%` ,marginRight}}>
  //             <div style={{ width: '100%', height: '100%', backgroundColor: color }} />
  //             <div style={{ position: 'absolute', top: '0px',paddingTop:'5px',paddingLeft:'1px',fontSize: '12px', color: 'black' }}>
  //               {percentage ? `${percentage}%` : ''}
  //             </div>
  //           </div>
  //         );
  //       })}
  //     </div>
  //   );
  // };
  

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        severity="success"
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        sx={{ marginTop: '2.9%', marginRight: '7%' }}
      >
        <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        severity="error"
        open={errorSnackbarOpen}
        autoHideDuration={2000}
        sx={{ marginTop: '2.9%', marginRight: '7%' }}
        onClose={() => setErrorSnackbarOpen(false)}
      >
        <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
      </Snackbar>
 

      <div className="d-grid" >
      

        <section  style={{ border: '1px solid lightgray',height:'170px'}}>
        
          <h6 className="text-light text-center p-2" style={{ backgroundColor: 'rgba(0,0,0,0.85)'}}>Assessment Report</h6>
       
          <div className="mx-4 mt-4 " style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <select value={selectedMonth || ''} onChange={handleMonthChange} style={{ marginRight: '10px', cursor:'pointer',border:'1px solid black' }}>
              <option value="" disabled>Select Month</option>
              {months.map((month) => (
                <option key={month.value} value={month.value}>{month.name}</option>
              ))}
            </select>
            <select value={selectedYear || ''} onChange={handleYearChange} style={{ cursor:'pointer' ,border:'1px solid black'}}>
              <option value="" disabled>Select Year</option>
              {years.map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          <div className="mb-4 mt-3 d-flex justify-content-center">
            <button className="btn btn-sm btn-danger mx-2" onClick={handleShow} disabled={!selectedMonth || !selectedYear || !report}>
              View Report
            </button>
          </div>
          <MonthlyReport showModal={showModal} onClose={handleClose} selectedMonth={selectedMonth} selectedYear={selectedYear} />
     
        </section>
      </div>
  
    </div>
  );
};

export default AssessorEstablishmentReport;

